export const MOCK_IMAGE_ASSETS = {
  respiratoryDashboard:
    "https://dummyimage.com/960x540/e8f0f8/1f2937.png&text=Respiratory+Dashboard+Snapshot",
  fuelMixChart:
    "https://dummyimage.com/960x540/f3f4f6/111827.png&text=Fuel+Mix+Chart",
  mealCard:
    "https://dummyimage.com/960x600/e7f5ef/0f172a.png&text=Mediterranean+Salmon+Bowl",
  workoutCard:
    "https://dummyimage.com/960x600/e6eef8/0f172a.png&text=Lower+Body+Strength",
  workoutExerciseSquat:
    "https://dummyimage.com/480x480/e2e8f0/0f172a.png&text=Goblet+Squat",
  workoutExerciseDeadlift:
    "https://dummyimage.com/480x480/e2e8f0/0f172a.png&text=Romanian+Deadlift",
};
